/* Decottaa teması – sekmeli koleksiyon vitrini (ana sayfa). */
(() => {
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(tab);
      });
      this.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(document.activeElement);
        if (index < 0) return;
        const last = this.tabs.length - 1;
        const next = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: last }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        const tab = this.tabs[(next + this.tabs.length) % this.tabs.length];
        this.select(tab);
        tab.focus();
      });
    }

    select(tab) {
      this.tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
    }
  }
  if (!customElements.get('collection-tabs')) customElements.define('collection-tabs', CollectionTabs);

  // Tema editöründe blok seçilince ilgili sekme açılır
  document.addEventListener('shopify:block:select', (event) => {
    const tabs = event.target.closest('collection-tabs');
    if (tabs && event.target.matches('[role="tab"]')) tabs.select(event.target);
  });
})();
